import { Card, CardContent, Box, Typography, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledCard = styled(Card)(({ theme }) => ({
	height: '100%',
	display: 'flex',
	flexDirection: 'column',
	transition: 'box-shadow 0.2s ease-in-out',
	'&:hover': {
		boxShadow: '0 8px 16px rgba(0,0,0,0.12)',
	},
}));

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	padding: theme.spacing(3),
	gap: theme.spacing(2),
	flex: 1,
	'&:last-child': {
		paddingBottom: theme.spacing(3),
	},
}));

const getFileIconColors = (resourcetype: string) => {
	switch (resourcetype) {
		case 'pdf':    return { bg: '#FDECEA', color: '#C62828' };
		case 'docx':   return { bg: '#E3F2FD', color: '#1565C0' };
		case 'pptx':   return { bg: '#FFF3E0', color: '#E65100' };
		case 'xlsx':   return { bg: '#E8F5E9', color: '#2E7D32' };
		case 'video':  return { bg: '#F3E5F5', color: '#6A1B9A' };
		case 'imagen': return { bg: '#E0F7FA', color: '#00697A' };
		case 'link':   return { bg: '#EDE7F6', color: '#4527A0' };
		default:       return { bg: '#F5F5F5',  color: '#616161' };
	}
};

export const FileIconBox = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'resourcetype',
})<{ resourcetype: string }>(({ theme, resourcetype }) => {
	const { bg, color } = getFileIconColors(resourcetype);
	return {
		width: 56,
		height: 56,
		borderRadius: theme.shape.borderRadius,
		backgroundColor: bg,
		color,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexShrink: 0,
		fontSize: '0.7rem',
		fontWeight: 800,
		letterSpacing: '0.04em',
	};
});

export const ContentBox = styled(Box)(() => ({
	flex: 1,
	minWidth: 0,
}));

export const FileName = styled(Typography)(({ theme }) => ({
	fontWeight: 600,
	color: theme.palette.text.primary,
	marginBottom: theme.spacing(0.5),
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	display: '-webkit-box',
	WebkitLineClamp: 2,
	WebkitBoxOrient: 'vertical',
}));

export const MetaText = styled(Typography)(({ theme }) => ({
	color: theme.palette.text.secondary,
	lineHeight: 1.4,
}));

export const FooterBox = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	marginTop: 'auto',
	paddingTop: theme.spacing(2),
	borderTop: `1px solid ${theme.palette.divider}`,
}));

export const DateText = styled(Typography)(({ theme }) => ({
	color: theme.palette.text.secondary,
}));

export const DownloadButton = styled(IconButton)(({ theme }) => ({
	color: theme.palette.text.secondary,
	'&:hover': {
		color: theme.palette.primary.main,
	},
}));
